import {
  FileMultiUploadResponse,
  FileMultiUploadRestResponse,
  FileUploadRequest,
  FileUploadResponse,
  FileUploadRestRequest,
  FileUploadRestResponse,
} from '@rp/shared/models';

const fromRest = (fileUploadResponse: FileUploadRestResponse): FileUploadResponse => {
  const fileUploadData = new FormData();

  if (!fileUploadResponse.presignedUploadUrl) {
    return {
      fileUploadData,
      fileUploadUrl: null,
      fileName: null,
      fileId: null,
    };
  }

  Object.entries(fileUploadResponse.presignedUploadFields).forEach(([key, value]) => {
    fileUploadData.append(key, value);
  });

  return {
    fileUploadData,
    fileUploadUrl: fileUploadResponse.presignedUploadUrl,
    fileName: fileUploadResponse?.fileName,
    fileId: fileUploadResponse?.fileId,
  };
};

const fromRestMulti = (
  fileMultiUploadResponse: FileMultiUploadRestResponse,
): FileMultiUploadResponse => {
  return {
    fileData: fileMultiUploadResponse.presignedFileData.map(fromRest),
  };
};

const toRest = (fileUploadRequest: FileUploadRequest): FileUploadRestRequest => {
  fileUploadRequest.fileUploadData.append('file', fileUploadRequest.file);

  return {
    fileUploadData: fileUploadRequest.fileUploadData,
    fileUploadUrl: fileUploadRequest.fileUploadUrl,
  };
};

export const FileUploadAdapter = {
  fromRestMulti,
  fromRest,
  toRest,
};
